// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"481":"40f59e4c","968":"4f16c510"}[chunkId] + ".js";
};